import styled from 'styled-components';

function Loading() {
  return (
    <LoadingContainer>
      <img src="/public/images/loader.gif" alt="loading" />
    </LoadingContainer>
  );
}

Loading.defaultProps = {};

export default Loading;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;
